import { Doctor } from "../types/doctor.definition";
import { PublicPatient } from "../types/patient.definition";
import { PaginationSettingsResponse, SearchRequest } from "../types/search.definition";
import { Secretary } from "../types/secretary.definition";
import {
  requestSearchDoctors,
  requestSearchSecretaries,
  searchAppointmentsInHealthcareFacility,
  searchDoctorsInHealthcareFacility,
  searchPatientsInHealthcareFacility,
  searchStaff,
} from "../webclients/search.client";

export const searchApi = {
  searchAppointmentsInFacility: async (data: SearchRequest, id: number) => {
    const response = await searchAppointmentsInHealthcareFacility(data, id);
    return response.data;
  },
  searchDoctorsInFacility: async (data: SearchRequest, id: number) => {
    const response = await searchDoctorsInHealthcareFacility(data, id);
    return response.data;
  },
  searchPatientsInFacility: async (
    data: SearchRequest,
    id: number
  ): Promise<{ data: PublicPatient[]; paginationSettings: PaginationSettingsResponse }> => {
    const response = await searchPatientsInHealthcareFacility(data, id);
    return response.data;
  },
  searchStaff: async (data: SearchRequest, facilityId: number) => {
    const response = await searchStaff(data, facilityId);
    return response.data;
  },
  searchDoctorsGlobal: async (data: SearchRequest): Promise<Doctor[]> => {
    const response = await requestSearchDoctors(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ((response.data as any)?.data ?? []) as Doctor[];
  },
  searchSecretariesGlobal: async (data: SearchRequest): Promise<Secretary[]> => {
    const response = await requestSearchSecretaries(data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ((response.data as any)?.data ?? []) as Secretary[];
  },
};
